import { http } from '@uhg-abyss/web/tools/http';
import { FLOW_ID } from '@src/common/AppConstants';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { getSourceSystem } from '../utility';

export const getClaim = async (payload) => {
  const { isDental, ...requestedPayload } = payload;
  const sourceSystem = getSourceSystem(payload.currentFlow);
  const url = `${payload.url}/${
    isDental ? 'dental' : 'provider'
  }/verifyClaim/v1`;

  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: {
      ...requestedPayload,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const verifyPaymentInfo = async (payload) => {
  const sourceSystem = getSourceSystem(payload.currentFlow);
  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}/provider/verifyPayment/v1`,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: {
      ...payload,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const verifyCompanyNameRequest = async (payload) => {
  const apiPath = {
    [FLOW_ID.BILLING]: '/billing/paa/submit/v1',
    [FLOW_ID.VENDOR]: '/vendor/paa/submit/v1',
  };

  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}${apiPath[payload.currentFlow]}`,
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: {
      requestId: payload.requestId,
      businessName: payload.businessName,
      phoneNumber: payload.phoneNumber,
      phoneExt: payload.phoneExt,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const validateCodeRequest = async (payload) => {
  const sourceSystem = getSourceSystem(payload.currentFlow);
  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}/provider/verifyKey/v1`,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: {
          ...error,
          type: 'codeRequestError',
          status: err.status,
        },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: payload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const tinAddressApiRequest = async (payload) => {
  const { isDental, ...requestPayload } = payload;
  const sourceSystem = getSourceSystem(payload.currentFlow);

  const url = `${payload.url}/${
    isDental ? 'dental' : 'provider'
  }/fetchAddress/v1`;

  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const errorData = {
        status: err.status,
        response: error,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: {
          ...error,
          type: 'codeRequestError',
          status: err.status,
        },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: requestPayload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const generateSecurityKeyRequest = async (payload) => {
  const sourceSystem = getSourceSystem(payload.currentFlow);
  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}/provider/generateKey/v1`,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const errorData = {
        url: window.location.href,
        status: err.status,
        response: error,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: {
          ...error,
          type: 'codeRequestError',
          status: err.status,
        },
      };
      return {
        data: {
          ...errObj,
        },
      };
    },
    body: payload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};
